import type { DeliverableAssignmentTableViewModel, DeliverableSubmissionTableViewModel, DeliverableTableViewModel } from 'ab-viewModels/deliverableTable.viewModel';

import { DeliverableReviewTypeLabelEnum } from '@acceligentllc/shared/enums/deliverableReviewType';

const CSV_DELIVERABLE_HEADER_KEYS = [
	'Status',
	'Job Id',
	'Start date',
	'End date',
	'QAQC assignee',
	'Delivery timeline',
];

const CSV_SUBMISSION_HEADER_KEYS = [
	'\tSubmission status',
	'Submission Id',
	'Submission date',
	'Work order work order Id',
	'Submission work order date of work',
	'Submission review type',
	'Delivery type',
];

const CSV_ASSIGNMENT_HEADER_KEYS = [
	'\t\tAssignment status',
	'Field worker',
	'Updated by',
	'Updated at',
];

export const toCSVData = (viewModels: DeliverableTableViewModel[]): string[][] => {
	const header: string[] = [...CSV_DELIVERABLE_HEADER_KEYS];

	const mapDeliverable = (deliverable: DeliverableTableViewModel): string[] => {
		return [
			deliverable?.status?.abbreviation ?? '-',
			deliverable?.jobCode ?? '-',
			deliverable?.startDate ?? '-',
			deliverable?.endDate ?? '-',
			deliverable?.deliverableAssignee ?? '-',
			deliverable?.deliverableDeliveryTimeline ?? '-',
		];
	};

	const mapSubmission = (submissions: DeliverableSubmissionTableViewModel): string[] => {
		return [
			`\t${submissions?.status?.abbreviation ?? '-'}`,
			submissions?.submissionId ?? '-',
			submissions?.submissionDate ?? '-',
			submissions?.workOrderCode ?? '-',
			submissions?.dueDate ?? '-',
			submissions?.reviewType ? DeliverableReviewTypeLabelEnum[submissions?.reviewType] : '-',
			submissions?.deliverableDeliveryMethod ?? '-',
		];
	};

	const mapAssignment = (assignment: DeliverableAssignmentTableViewModel): string[] => {
		return [
			`\t\t${assignment?.status?.abbreviation ?? '-'}`,
			assignment?.employee ?? '-',
			assignment?.updatedBy?.fullName ?? '-',
			assignment?.updatedAt.toString() ?? '-',
		];
	};

	const rows: string[][] = viewModels.reduce((_acc, _deliverable) => {
		_acc.push(mapDeliverable(_deliverable));

		if (_deliverable.submissions.rows?.length) {
			_acc.push(CSV_SUBMISSION_HEADER_KEYS);
			for (const _submission of _deliverable.submissions.rows) {
				_acc.push(mapSubmission(_submission));

				if (_submission.assignments.rows?.length) {
					_acc.push(CSV_ASSIGNMENT_HEADER_KEYS);
					_acc.push(..._submission.assignments.rows.map(mapAssignment));
				}
			}
		}
		return _acc;
	}, [] as string[][]);

	return [header, ...rows];
};
